import { useState } from 'react';

import { Campaign } from 'domains/campaigns/types';
import ConfirmationDialog from 'domains/core/components/ConfirmationDialog';
import ErrorSnackbar from 'domains/core/components/Snackbars/ErrorSnackbar';
import InfoSnackbar from 'domains/core/components/Snackbars/InfoSnackbar';
import SuccessSnackbar from 'domains/core/components/Snackbars/SuccessSnackbar';
import useUnarchiveCampaignItem from 'hooks/useUnarchiveCampaignItem';

export type Props = {
    activeItem: Campaign;
    handleModalClose: () => void;
    isOpen: boolean;
    refetchTableData: () => void;
    resetActiveItem: () => void;
};

const UnarchiveCampaignModal = ({ activeItem, handleModalClose, isOpen, refetchTableData, resetActiveItem }: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const { getUnarchiveItemFunction, isLoading, isSuccess } = useUnarchiveCampaignItem({
        activeItem,
        refetchTableData,
        resetActiveItem,
        setErrorMessage,
        setSuccessMessage,
    });

    const handleUnarchive = () => {
        const unarchiveItem = getUnarchiveItemFunction();
        unarchiveItem();
        handleModalClose();
    };

    const onCancel = () => {
        handleModalClose();
        resetActiveItem();
    };

    const infoMessage = `Unarchiving "${activeItem?.name}"`;
    const contentText = `You are about to unarchive "${activeItem?.name}." This will move the curation back to the main list.`;

    return (
        <>
            {errorMessage && <ErrorSnackbar errorMessage={errorMessage} />}
            {isLoading && <InfoSnackbar successMessage={infoMessage} />}
            {isSuccess && <SuccessSnackbar successMessage={successMessage} />}
            <ConfirmationDialog
                dialogProps={{
                    confirmButtonText: 'Unarchive',
                    contentText,
                    title: 'Unarchive curation',
                }}
                onCancel={onCancel}
                onConfirm={handleUnarchive}
                onModalClose={handleModalClose}
                open={isOpen}
            />
        </>
    );
};

export default UnarchiveCampaignModal;
